import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { useGWAnalytics } from '@/plugins/analytics'
import { IonSegment, IonSegmentButton } from '@ionic/vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { useGWAnalyticsBasePayload } from '@/plugins/analytics/composables/analyticsBasePayload'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeLocale',
  setup(__props) {

const analytics = useGWAnalytics()
const { payload } = useGWAnalyticsBasePayload()
const { locale } = useI18n()
const store = useStore()

const changeLocale = (event: CustomEvent) => {
  locale.value = event.detail.value
  store.commit('updatedLocale', event.detail.value)
	analytics.track('click', {
		...payload.value,
		name: `language picker ${event.detail.value}`,
		value: event.detail.value
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonSegment), {
    value: _ctx.$store.state.locale,
    class: "mr-2 sm:mr-0 sm:ml-5 h-[2.125rem] [--background:#171717] rounded-full",
    onIonChange: changeLocale
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$i18n.availableLocales, (lang, i) => {
        return (_openBlock(), _createBlock(_unref(IonSegmentButton), {
          key: i,
          value: lang,
          class: "[--border-radius:9999px] [--color-checked:#fff] [--color:theme(colors.grey)] [--indicator-color:theme(colors.primary)] uppercase my-0 min-w-[3rem] min-h-[1.625rem]"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(lang), 1)
          ]),
          _: 2
        }, 1032, ["value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value"]))
}
}

})